import React from 'react';
import './style.css';

// 모바일은 데스크톱과 동일한 컴포넌트 사용 (CSS 반응형으로 처리)
import Download from './index';

export default function MobileDownload() {
    return <Download />;
}
